/* Velta produktsida: galleri, varianter, antal, leveransdatum, fast köpknapp. */
(function () {
  if (window.__veltaInit) return;
  window.__veltaInit = true;

  function formatMoney(cents, format) {
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelims(n, precision, thousands, decimal) {
      var parts = (n / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = (format || '{{amount}}').match(placeholder);
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelims(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = withDelims(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelims(cents, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'", '.'); break;
      default: value = withDelims(cents, 2, ',', '.');
    }
    return format.replace(placeholder, value);
  }

  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }

  function initPdp(root) {
    var dataEl = root.querySelector('[data-v-json]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var track = root.querySelector('[data-v-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-v-thumb]'));

    /* Galleri */
    function setActive(i) {
      thumbs.forEach(function (t) { t.setAttribute('aria-current', String(Number(t.dataset.vThumb) === i)); });
    }
    function goTo(i, smooth) {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(i);
    }
    function currentIndex() {
      return track ? Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)) : 0;
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(Number(t.dataset.vThumb)); }); });
    var prev = root.querySelector('[data-v-prev]');
    var next = root.querySelector('[data-v-next]');
    if (prev) prev.addEventListener('click', function () { goTo(Math.max(currentIndex() - 1, 0)); });
    if (next) next.addEventListener('click', function () { goTo(Math.min(currentIndex() + 1, slides.length - 1)); });
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { setActive(currentIndex()); });
      }, { passive: true });
    }

    /* Varianter */
    var input = root.querySelector('[data-v-variant-input]');
    var priceNow = root.querySelector('[data-v-price-now]');
    var priceWas = root.querySelector('[data-v-price-was]');
    var klarna = root.querySelector('[data-v-klarna]');
    var label = root.querySelector('[data-v-label]');
    var atc = root.querySelector('[data-v-atc]');
    var atcText = root.querySelector('[data-v-atc-text]');
    var stickyPrice = root.querySelector('[data-v-sticky-price]');
    var stickyBtn = root.querySelector('[data-v-sticky-btn]');
    var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-v-swatch]'));

    function selectVariant(id, btn) {
      var v = data.variants.filter(function (x) { return x.id === id; })[0];
      if (!v) return;
      input.value = v.id;
      swatches.forEach(function (s) { s.setAttribute('aria-checked', String(s === btn)); });
      if (label && btn) label.textContent = btn.dataset.label;
      if (priceNow) priceNow.textContent = formatMoney(v.price, data.moneyFormat);
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price, data.moneyFormat);
      if (priceWas) {
        priceWas.hidden = !(v.compare > v.price);
        if (v.compare > v.price) priceWas.textContent = formatMoney(v.compare, data.moneyFormat);
      }
      if (klarna) klarna.textContent = formatMoney(Math.ceil(v.price / 300) * 100, data.moneyFormat);
      [atc, stickyBtn].forEach(function (b) { if (b) b.disabled = !v.available; });
      if (atcText) atcText.textContent = v.available ? data.atc : 'Slutsåld';
      if (v.media) {
        var idx = slides.findIndex(function (s) { return Number(s.dataset.mediaId) === v.media; });
        if (idx > -1) goTo(idx);
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      syncBundle();
    }
    swatches.forEach(function (s) {
      s.addEventListener('click', function () { selectVariant(Number(s.dataset.vSwatch), s); });
    });

    /* Kaching-paket: huvudpris, fast köpknapp och Klarna visar priset för valt paket, inte styckpriset */
    function selectedBar() {
      var n = document.querySelector('input[type="radio"][name^="kaching-bundles-deal"]:checked');
      while (n && !(n.querySelector && n.querySelector('.kaching-bundles__bar-price'))) n = n.parentElement;
      return n;
    }
    function bundlePrice() {
      var bar = selectedBar();
      var el = bar && bar.querySelector('.kaching-bundles__bar-price');
      return el ? el.textContent.trim() : null;
    }
    function syncBundle() {
      var t = bundlePrice();
      if (!t) return;
      if (stickyPrice) stickyPrice.textContent = t;
      /* Huvudpriset följer paketet. Överstruket = antal × ordinarie styckpris, som Kaching själv visar. */
      if (priceNow) priceNow.textContent = t;
      if (priceWas) {
        var full = selectedBar().querySelector('.kaching-bundles__bar-full-price');
        var ft = full ? full.textContent.trim() : '';
        priceWas.hidden = !ft || ft === t;
        if (ft && ft !== t) priceWas.textContent = ft;
      }
      if (klarna) {
        var kr = Number(t.replace(/[^\d]/g, ''));
        if (kr) klarna.textContent = formatMoney(Math.ceil(kr / 3) * 100, data.moneyFormat).replace(/[,.]00(?!\d)/, '');
      }
    }
    document.addEventListener('change', function (e) {
      if (e.target && /^kaching-bundles-deal/.test(e.target.name || '')) syncBundle();
    });
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.kaching-bundles__bars')) setTimeout(syncBundle, 60);
    });
    var tries = 0;
    var poll = setInterval(function () { if (bundlePrice() || ++tries > 40) { clearInterval(poll); syncBundle(); } }, 250);

    /* Antal */
    var qty = root.querySelector('[data-v-qty-input]');
    root.querySelectorAll('[data-v-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = Math.min(99, Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.dataset.vQty)));
        qty.value = n;
      });
    });

    /* Leveransdatum, från butikens angivna arbetsdagar */
    var eta = root.querySelector('[data-v-eta]');
    if (eta) {
      var min = Number(root.dataset.etaMin) || 5;
      var max = Number(root.dataset.etaMax) || 12;
      var fmt = new Intl.DateTimeFormat('sv-SE', { day: 'numeric', month: 'short' });
      var now = new Date();
      eta.textContent = fmt.format(addBusinessDays(now, min)) + ' – ' + fmt.format(addBusinessDays(now, max));
    }

    /* Fast köpknapp: visas när köpknappen scrollats ur bild */
    var sticky = root.querySelector('[data-v-sticky]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', past);
        sticky.setAttribute('aria-hidden', String(!past));
        if (stickyBtn) stickyBtn.tabIndex = past ? 0 : -1;
      }).observe(atc);
    }
  }

  function boot() { document.querySelectorAll('[data-v-pdp]').forEach(initPdp); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-v-pdp]');
    if (el) initPdp(el);
  });
})();
